<template>
  <div
    :class="
      browserSize.xs === true || browserSize.sm === true
        ? 'methods'
        : 'methods2'
    "
  >
    <v-row>
      <v-col>
        <img
          width="150"
          height="150"
          class="iconMargin"
          src="../assets/omt.png"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
    </v-row>

    <p class="paragraph"><b>Wskazania:</b></p>
    <li class="paragraph2" v-for="item in wskazania" :key="item.index">
      {{ item }}
    </li>

    <v-row>
      <v-col class="col-11">
        <span class="aboutText">
          {{ opis1 }}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-11">
        <span class="aboutText">
          {{ opis2 }}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-11">
        <p class="paragraph3"><b>Trakcja</b>{{ opis3 }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-11">
        <p class="paragraph3"><b>Mobilizacja</b>{{ opis4 }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-11">
        <p class="paragraph3"><b>Manipulacja</b>{{ opis5 }}</p>
      </v-col>
    </v-row>

    <p class="paragraph">
      <b>{{ opis6 }}</b>
    </p>
    <li class="paragraph2" v-for="item in list" :key="item.index">
      {{ item }}
    </li>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Terapia manualna według Kaltenborna",
      wskazania: [
        "ból związany z chorobą dyskową kręgosłupa (uszkodzenie krążka międzykręgowego, wypukliny i przepukliny krążka),",
        "ból promieniujący do kończyn związany z uciskiem i podrażnieniem korzeni nerwowych (tzw. zapalenie korzonków nerwowych),",
        "ból spowodowany chorobą zwyrodnieniową stawów międzykręgowych (artrozą),",
        "ból spowodowany wzmożonym napięciem mięśni,",
        "sztywność spowodowana przykurczem lub zablokowaniem stawów międzykręgowych i krzyżowo-biodrowych,",
        "bóle głowy pochodzenia odkręgosłupowego.",
      ],
      opis1:
        "W terapii manualnej według Kaltenborna wykorzystuje się następujące techniki działania: trakcja, mobilizacja, manipulacja oraz mobilizacja tkanek miękkich. Są to techniki pracy bezpośrednio na połączeniach stawowych. Jeśli wskutek pracy na połączeniach stawowych nie dochodzi do wyraźnie odczuwalnej poprawy stanu pierwotnego, czyli zniesienia objawów bólowych stawu lub innej okolicy ciała, w którą ból promieniuje, podejmowana jest praca bezpośrednio na zmienionym chorobowo stawie. Wykonywane wówczas czynności polegają na przesunięciu kości danego stawu w niewielkim zakresie względem siebie.",
      opis2:
        "Zastosowane w terapii techniki mają bezpośredni wpływ na poprawię krążenie płynu stawowego, odblokowują nieprawidłowo ustawione względem siebie powierzanie stawowe, odciążają chrząstkę stawową i poprawiają lokalne unerwienie.",
      opis3:
        ", to czynność polegająca na oddaleniu powierzchni stawowych i wyrównaniu ciśnienia wewnątrzstawowego chorobowo zmienionego stawu.",
      opis4:
        ", to czynność lub zespół czynności wykonywanych w końcowym zakresie utraconego ruchu stawowego, w ścisłej współpracy z pacjentem, w celu stopniowego przywracania ruchomość.",
      opis5:
        ", to zabieg mobilizacji z szybkim impulsem, w którym udział pacjenta polega na rozluźnieniu tkanek miękkich (mięśni) okalających miejsce poddane zabiegowi lub kontrolowaniu oddechu, który wspomaga napinanie i rozluźnianie mięśni. Zazwyczaj techniki pracy na elementach twardych wymagają pozycji ułożeniowej powodującej rozluźnienie stawu.",
      opis6: "Mobilizacja tkanek miękkich, to proces ich rozluźnienia poprzez:",
      list: [
        "masaż funkcyjny,",
        "masaż poprzeczny,",
        "uczucie intensywnego ciepła lub zimna,",
        "poizometryczna relaksacja,",
        "rozciąganie (stretching).",
      ],
    };
  },
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.methods {
  margin-top: 12vh;
}
.methods2 {
  margin-top: 4vh;
}
.v-application .grey--text {
  color: #414149 !important;
}
.infText {
  margin: auto;
}
.paragraph {
  font-weight: bold;
  margin-top: 10px;
  text-align: left;
  margin-left: 6vw;
  margin-right: 3vw;
}
.paragraph2 {
  text-align: left;
  margin-left: 7vw;
  margin-right: 3vw;
}
.paragraph3 {
  text-align: justify;
  text-align-last: left;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: justify;
  text-align-last: left;
}
.aboutText {
  text-align-last: left;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent: 1.5em;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.col-11 {
  flex: 0 0 91.666667%;
  max-width: 91.666667%;
  align-content: center;
  display: flex;
  margin: auto;
}
</style>